import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaReceipt, FaPrint, FaDownload, FaEye } from 'react-icons/fa';

const ReceiptsView = ({ userInfo, API_BASE_URL, auth }) => {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReceipts();
  }, []);

  const fetchReceipts = async () => {
    try {
      setLoading(true);

      // Validate zone assignment
      if (!userInfo.zone_id) {
        console.warn('No zone assigned to field officer');
        setReceipts([]);
        setLoading(false);
        return;
      }

      const response = await axios.get(
        `${API_BASE_URL}/receipts?userRole=Revenue Officer&user_id=${userInfo.user_id}&zone_id=${userInfo.zone_id}`,
        auth
      );
      setReceipts(response.data);
    } catch (error) {
      console.error('Error fetching receipts:', error);
    } finally {
      setLoading(false);
    }
  };

  const printReceipt = (receipt) => {
    // Implement print functionality
    window.print();
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <div>Loading receipts...</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h1 style={{ margin: '0 0 2rem 0', color: '#2c3e50' }}>
        <FaReceipt style={{ marginRight: '0.5rem' }} />
        Receipts
      </h1>

      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.5rem',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
        {receipts.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '3rem',
            color: '#7f8c8d'
          }}>
            <FaReceipt size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
            <h3>No receipts found</h3>
            <p>No receipts have been generated yet.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>
                    Receipt Number
                  </th>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>
                    Date Issued
                  </th>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>
                    Amount
                  </th>
                  <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '1px solid #dee2e6' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {receipts.map((receipt, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '1rem', fontFamily: 'monospace' }}>
                      {receipt.receipt_number}
                    </td>
                    <td style={{ padding: '1rem' }}>
                      {new Date(receipt.issued_at).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '1rem', fontWeight: '600', color: '#27ae60' }}>
                      GHS {parseFloat(receipt.amount || 0).toFixed(2)}
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button
                          onClick={() => printReceipt(receipt)}
                          style={{
                            padding: '0.5rem',
                            backgroundColor: '#3498db',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.25rem',
                            cursor: 'pointer'
                          }}
                          title="Print Receipt"
                        >
                          <FaPrint size={14} />
                        </button>
                        <button
                          style={{
                            padding: '0.5rem',
                            backgroundColor: '#27ae60',
                            color: 'white',
                            border: 'none',
                            borderRadius: '0.25rem',
                            cursor: 'pointer'
                          }}
                          title="Download Receipt"
                        >
                          <FaDownload size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceiptsView;
